import DashboardLayout from "../layouts/DashboardLayout";
import RoleBasedDashboard from "../components/RoleBasedDashboard/RoleBasedDashboard";
import QuizDashboard from "../pages/QuizDashboard/QuizDashboard";
import ETSQuizDashboard from "../pages/ETSQuizDashboard/ETSQuizDashboard";
import AdminPage from "../pages/AdminPage/AdminPage";
import ForcedChoiceQuizDashboard from "../pages/ForcedChoiceQuizDashboard/ForcedChoiceQuizDashboard";

export const privateRoutes = [
  {
    path: '/dashboard',
    element: <DashboardLayout />,
    protected: true,
    roles: ['coach', 'athlete'],
    children: [
      {
        index: true,
        element: <RoleBasedDashboard />
      },
      {
        path: 'quiz',
        element: <QuizDashboard />
      },
      {
        path: 'gscore-quiz',
        element: <ETSQuizDashboard />
      },
      {
        path: 'trait-quiz',
        element: <ForcedChoiceQuizDashboard />
      }
    ]
  },
  {
    path: '/admin',
    element: <AdminPage />,
    protected: true,
    roles: ['admin']
  }
];